import { CSSProperties } from 'react';

export const colors = {
  bg: '#EEF1FB',
  card: '#FFFFFF',
  border: '#E5E7EB',
  inputBg: '#F3F4F6',
  text: '#111827',
  muted: '#6B7280',
  primary: '#0A0A0A',
  accent: '#2563EB',
  accentSoft: '#DBEAFE',
  success: '#10B981',
  danger: '#EF4444',
};

export const layout: Record<string, CSSProperties> = {
  page: {
    minHeight: '100vh',
    background: `linear-gradient(180deg, ${colors.bg} 0%, #E2E8F8 100%)`,
    padding: '40px 16px 80px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: colors.text,
  },
  container: {
    maxWidth: 820,
    margin: '0 auto',
  },
  card: {
    background: colors.card,
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.06)',
    padding: 32,
  },
  back: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    color: colors.text,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 16,
    padding: 0,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: colors.muted,
    margin: '8px 0 0',
  },
  label: {
    display: 'block',
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 6,
    color: colors.text,
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    background: colors.inputBg,
    border: `1px solid transparent`,
    borderRadius: 8,
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    background: colors.inputBg,
    border: `1px solid transparent`,
    borderRadius: 8,
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box',
    appearance: 'none',
  },
  row: {
    display: 'grid',
    gap: 16,
    marginBottom: 16,
  },
  primaryBtn: {
    background: colors.primary,
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '12px 20px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
  secondaryBtn: {
    background: '#fff',
    color: colors.text,
    border: `1px solid ${colors.border}`,
    borderRadius: 10,
    padding: '12px 18px',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  disabledBtn: {
    background: '#9CA3AF',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '12px 20px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'not-allowed',
  },
  optionCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '14px 16px',
    background: '#fff',
    border: `1px solid ${colors.border}`,
    borderRadius: 10,
    cursor: 'pointer',
    fontSize: 14,
    marginBottom: 10,
  },
  optionCardSelected: {
    borderColor: colors.accent,
    background: colors.accentSoft,
  },
  infoBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    background: colors.accentSoft,
    borderRadius: 10,
    padding: 14,
    fontSize: 13,
    color: '#1E3A8A',
    marginBottom: 20,
  },
  divider: {
    border: 'none',
    borderTop: `1px solid ${colors.border}`,
    margin: '20px 0',
  },
};
